import debounce from 'lodash/debounce'
riot.tag2('image-gallery', '  <div class="col-sm-6">\n    <div class="form-inline">\n      <div class="input-group btn btn-primary btn-file" if="{checkPermission(&quot;images&quot;, &quot;0100&quot;)}">\n        <input id="importFile" name="files" onchange="{upload}" type="file" multiple="multiple" accept="image/*"><i class="fa fa-plus"></i> Добавить\n      </div>\n      <button class="btn btn-danger" if="{selectedCount &amp;&amp; checkPermission(&quot;images&quot;, &quot;0001&quot;)}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash"></i></button>\n      <button class="btn btn-danger" if="{!opts.hideUnised checkPermission(&quot;images&quot;, &quot;0001&quot;)}" onclick="{removeUnused}" type="button"><i class="fa fa-trash"></i> Удалить неиспользуемые</button>\n    </div>\n  </div>\n  <div class="col-sm-6">\n    <form class="form-inline text-right m-b-2">\n      <div class="form-group">\n        <div class="input-group">\n          <input class="searchCatalog form-control" name="search" type="text" title="Поиск (Ctrl+F)" placeholder="Поиск" onkeyup="{find}"><span class="input-group-btn">\n            <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n        </div>\n      </div>\n    </form>\n  </div>\n  <div class="table-responsive col-sm-12">\n    <datatable cols="{cols}" rows="{items}" handlers="{handlers}" dblclick="{opts.dblclick}">\n      <datatable-cell name="">\n        <div class="image-prev"><img riot-src="{row.imageUrlPreview}" width="64"></div>\n      </datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="sizeDisplay">{row.sizeDisplay}</datatable-cell>\n      <datatable-cell name="weight">{row.weight}</datatable-cell>\n    </datatable>\n  </div>\n  <bs-pagination name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n', '.image-prev { border-width: 1px; border-color: #F2F2F2; border-style: solid; display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-align-items: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-flex: auto; -ms-flex: auto; -webkit-box-flex: 1; flex: auto; width: 64px; height: 64px; overflow: hidden; -moz-border-radius: 4px; -webkit-border-radius: 4px; border-radius: 4px; }', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');

self.cols = [{ name: '', value: 'Картинка' }, { name: 'name', value: 'Наименование' }, { name: 'sizeDisplay', value: 'Размер (px)' }, { name: 'weight', value: 'Вес (байт)' }];

self.handlers = {
    getImageUrl: function getImageUrl(name) {
        if (name.indexOf('http://') == -1 && name.indexOf('https://') == -1) {
            return app.getImagePreviewURL(name, self.params.section);
            //return app.config.imagePreviewURL + self.params.section + '/' + name
        } else {
            return name;
        }
    }
};

self.find = debounce(function (e) {
    if (e.key !== 'Control' && (e.key !== 'f' || self.lastEvent !== 1)) {
        if (self.pages.current > self.pages.count) self.pages.current = 1;
        self.reload();
        self.lastEvent = 0;
    }
}, 400);

self.items = [];
self.params = {};

self.pages = {
    count: 0,
    current: 1,
    limit: 11,
    change: function change(e) {
        self.pages.current = e.currentTarget.page;
        self.params.limit = self.pages.limit;
        self.params.offset = (self.pages.current - 1) * self.pages.limit;
        if (self.params.offset < 0) self.params.offset = 0;
        observable.trigger('images-page-change', self.params);
        self.reload();
    }
};

self.reload = function () {
    if (self.params.limit && self.params.offset) self.pages.current = self.params.offset / self.params.limit + 1;
    if (self.search) {
        self.params.searchText = self.search.value;
    }

    API.request({
        object: 'Image',
        method: 'Fetch',
        data: self.params,
        success: function success(response) {
            self.pages.count = Math.ceil(response.count / self.pages.limit);
            if (self.pages.current > self.pages.count) {
                self.pages.current = self.pages.count;
            }
            self.items = response.items;
            self.tags.paginator.update({ pages: self.pages.count, page: self.pages.current });
            self.update();
        },
        error: function error(response) {
            self.pages.count = 1;
            self.pages.current = 1;
            self.items = [];
            self.tags.paginator.update({ pages: self.pages.count, page: self.pages.current });
            self.update();
        }
    });
};

self.removeUnused = function (e) {

    API.request({
        object: 'Image',
        method: 'Delete',
        data: { isUnused: true, section: self.params.section },
        success: function success(response) {
            popups.create({ title: 'Успех!', text: 'Неиспользованные картинки удалены', style: 'popup-success' });
            self.reload();
        }
    });
};

self.remove = function (e) {
    modals.create('bs-alert', {
        type: 'modal-danger',
        title: 'Предупреждение',
        text: 'Вы точно хотите удалить выделенные картинки?',
        size: 'modal-sm',
        buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
        callback: function callback(action) {
            if (action === 'yes') {
                var files = self.tags.datatable.getSelectedRows().map(function (item) {
                    return item.name;
                });

                var params = {
                    section: self.params.section,
                    files: files
                };

                API.request({
                    object: 'Image',
                    method: 'Delete',
                    data: params,
                    success: function success(response) {
                        self.selectedCount = 0;
                        self.reload();
                        popups.create({ style: 'popup-success', title: 'Успех!', text: 'Удалено' });
                    }
                });
            }
            this.modalHide();
        }
    });
};

self.upload = function (e) {
    var formData = new FormData();

    for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file' + i, e.target.files[i], e.target.files[i].name);
    }
    API.upload({
        section: self.params.section,
        count: e.target.files.length,
        data: formData,
        success: function success(response) {
            if (Array.isArray(response.items) && response.items.length) {
                self.items = response.items.concat(self.items);
            }

            self.update();

            if (typeof opts.autoselect === 'function' && response.items && response.items[0]) {
                opts.autoselect.bind(self)(response.items[0]);
            }
        }
    });
    $("#importFile").val(undefined);
};

self.one('updated', function () {
    self.tags.datatable.on('row-selected', function (count) {
        self.selectedCount = count;
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/images/image-gallery.tag